import { SET_SEARCH_CLAIM } from './types';

export const setSearchClaim = (searchClaim) => ({
  type: SET_SEARCH_CLAIM,
  payload: searchClaim,
});
